import type React from 'react';

import { Html } from '#src/app/shared/components/html';

import { useFadeTransition } from './hooks/useFadeTransition';
import { useImpressionCalculation } from './hooks/useImpressionCalculation';

export const ImpressionCalculation: React.FC<EmptyProps> = () => {
	const {
		data: { text, display },
	} = useImpressionCalculation();

	const fade = useFadeTransition(display);

	if (!fade.shouldRender) return null;

	return <Html as="div" html={text} className="text-typography-weak md:text-lg" style={fade.style} />;
};
